import hostname from './config.host';
import { fetchWrapper } from './fetch-wrapper';
const apiUrl: string = `${hostname}/aladdin_api/v1`;

const getForecastersList = (oauthTokenHeader:string, selectedSharedUid: string, year: string) =>{
  return fetchWrapper.get(`${apiUrl}/asset_management/overview/forecaster/${selectedSharedUid}/?year=${year}`, oauthTokenHeader);
};

function getAllWebsiteTarget(oauthTokenHeader:string,website_shared_uid:any){
    return fetchWrapper.get(`${apiUrl}/asset_management/overview/website_targets/${website_shared_uid}/`,oauthTokenHeader);
};

const getPastMonthForcast = (oauthTokenHeader:string,  QUERY_ID: string,  selectedSharedUid: string, date: string, forecast_content_shared_uid: string) => {
  return fetchWrapper.get(`${apiUrl}/biz_layer_query/run/${QUERY_ID}/?date=${date}&website_shared_uid=${selectedSharedUid}&forecast_content_shared_uid=${forecast_content_shared_uid}`, oauthTokenHeader);
}

const getForecasterGraphAndTableData = (oauthTokenHeader: string, QUERY_ID: string, selectedSharedUid: string, date: string, metric: string) => {
  return fetchWrapper.get(`${apiUrl}/biz_layer_query/run/${QUERY_ID}/?website_shared_uid=${selectedSharedUid}&date=${date}&metric=${metric}`, oauthTokenHeader);
};

const getForecasterLastYearData = (oauthTokenHeader: string, QUERY_ID: string, selectedSharedUid: string, date: string, metric: string) => {
  return fetchWrapper.get(`${apiUrl}/biz_layer_query/run/${QUERY_ID}/?website_shared_uid=${selectedSharedUid}&date=${date}&metric=${metric}`, oauthTokenHeader);
};

const getForecasterLastTwelveMonthsData = (oauthTokenHeader: string, QUERY_ID: any, selectedSharedUid: string) => {
  return fetchWrapper.get(`${apiUrl}/biz_layer_query/run/${QUERY_ID}/?website_shared_uid=${selectedSharedUid}`, oauthTokenHeader);
};

const createNewForecast = (oauthTokenHeader: string, data:any, selectedSharedUid: string) => {
   return fetchWrapper.post(`${apiUrl}/asset_management/overview/forecaster/${selectedSharedUid}/`,data, oauthTokenHeader);
}

function getAllUsers(oauthTokenHeader: any) {
  return fetchWrapper.get(`${apiUrl}/admin/users/?active_only=True/`, oauthTokenHeader);
}

//Add comments for forecast
function postComment(oauthTokenHeader: string, data: any, object_shared_uid: any) {
  return fetchWrapper.post(`${apiUrl}/utilities/comments/${object_shared_uid}/`, data, oauthTokenHeader);
}

//Get comments for forecast
function getComments(oauthTokenHeader: string, object_shared_uid: any) {
  return fetchWrapper.get(`${apiUrl}/utilities/comments/${object_shared_uid}/`, oauthTokenHeader);
}
//Update comments for forecast
function putComments(oauthTokenHeader: string,data: any,object_shared_uid: any) {
  return fetchWrapper.put(`${apiUrl}/utilities/comments/${object_shared_uid}/`,data,oauthTokenHeader);
}
//Delete comments for forecast
function deleteComment(oauthTokenHeader: string, object_shared_uid: any, comment_shared_uid: any) {
  return fetchWrapper.delete(`${apiUrl}/utilities/comments/${object_shared_uid}/?comment=${comment_shared_uid}`, oauthTokenHeader);
}
//Upload file for forecast
function uploadFile(oauthTokenHeader: string,data: any,object_shared_uid: any) {
  return fetchWrapper.post(`${apiUrl}/utilities/file/${object_shared_uid}/`,data,oauthTokenHeader);
}

//Get files for forecast
function getFiles(oauthTokenHeader: string, object_shared_uid: any) {
  return fetchWrapper.get(`${apiUrl}/utilities/file/${object_shared_uid}/`,oauthTokenHeader);
}

//Delete file for forecast
function deleteFile(oauthTokenHeader: string, file_shared_uid: any) {
  return fetchWrapper.delete(`${apiUrl}/utilities/file/${file_shared_uid}/`, oauthTokenHeader);
}

export const forecastersService = {getForecastersList, getAllWebsiteTarget, getPastMonthForcast, getForecasterGraphAndTableData, getForecasterLastYearData, getForecasterLastTwelveMonthsData, createNewForecast, getAllUsers, postComment, getComments, putComments, deleteComment, uploadFile, getFiles, deleteFile};
